package org.hs_soft.runmynesto.domain.model.home.template.add_new_category


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class AddNewCategory(
    @SerialName("data")
    val  data : Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)